export default "__VITE_ASSET__BzksA00t__"